<template>
	<div class="container">
		<el-container>
			<el-header class="header">
				<headers />
			</el-header>
			<el-container>
				<slider />
				<el-main>
					<div class="main_box">
						<div class="main_main">
							<!-- Page Header -->
							<div class="page_header">{{ pageTitle }}</div>
							<!-- Page Header -->
							<div class="page_main">
								<div class="btn_el">
									<div class="tips">
										Please enter the name of the new department and provide a description.
									</div>
								</div>

								<div class="form_box">
									<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px">
										<div class="input_el">
											<div class="tit required">Department Name</div>
											<el-form-item label="" prop="departments_name">
												<el-input v-model="ruleForm.departments_name" placeholder="Please enter"
													clearable></el-input>
											</el-form-item>
										</div>

										<div class="input_el">
											<div class="tit required">Department Description</div>
											<el-form-item label="" prop="description">
												<el-input type="textarea" :rows="5" v-model="ruleForm.description"
													placeholder="Please enter"></el-input>
											</el-form-item>
										</div>

										<div class="btn_el">
											<div class="tips">
												Select the company and department manager, then click "Save".
												The department will be enabled by default.
												(Please make sure the company information has been completed before
												adding a department.)
											</div>
										</div>

										<!-- <div class="input_el">
                      <div class="tit required">Company</div>
                      <el-form-item label="" prop="company_id">
                        <el-select
                          v-model="ruleForm.company_id"
                          placeholder="Please select"
                          style="width: 100%"
                        >
                          <el-option
                            v-for="value in companyList"
                            :key="value.id"
                            :label="value.company_name"
                            :value="value.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </div> -->

										<div class="input_el">
											<div class="tit required">Department Manager</div>
											<el-form-item label="" prop="departments_userid">
												<el-input v-model="userName" placeholder="Please select"
													@click.native="openUserDialog">
													<i slot="suffix" class="el-input__icon el-icon-user"></i>
												</el-input>
											</el-form-item>
										</div>
									</el-form>
								</div>

								<div class="btn_box">
									<van-button class="btn_el" type="default" round @click="cancel">
										Cancel
									</van-button>

									<van-button class="btn_el" round color="linear-gradient(to right, #7BC1FF, #4886FF)"
										@click="submitForm('ruleForm')">
										Save
									</van-button>
								</div>
							</div>
						</div>
					</div>
				</el-main>
			</el-container>
		</el-container>

		<!-- User Selection Dialog -->
		<UserSelect :visible.sync="dialogVisible" :user-list="usersList" :selected-id="selectedId"
			@confirm="handleConfirm" />
		<!-- User Selection Dialog -->

		<!-- Loading -->
		<transition name="fade">
			<div class="loading" v-show="isLoading">
				<van-loading />
			</div>
		</transition>
		<!-- Loading -->
	</div>
</template>

<script>
	import {
		departmentsAdd,
		departmentsEdit,
		departmentsDetail,
	} from "@/api/system/department";
	// import { companyList } from "@/api/system/company";
	import {
		usersList
	} from "@/api/system/user";
	import headers from "@/component/header.vue";
	import slider from "@/component/slider.vue";
	import UserSelect from "@/component/user-select.vue";
	export default {
		components: {
			headers,
			slider,
			UserSelect,
		},
		data() {
			return {
				isLoading: true,
				pageTitle: "",
				userName: "",
				selectedId: null,
				dialogVisible: false,
				ruleForm: {
					departments_name: "",
					description: "",
					// company_id: "",
					departments_userid: "",
				},
				rules: {
					departments_name: [{
						required: true,
						message: "Please enter",
						trigger: "blur"
					}, ],
					description: [{
						required: true,
						message: "Please enter",
						trigger: "blur"
					}],
					// company_id: [{
					// 	required: true,
					// 	message: "Please select",
					// 	trigger: "change"
					// }],
					departments_userid: [{
						required: true,
						message: "Please select",
						trigger: "change"
					}, ],
				},
				// companyList: [],
				usersList: [],
			};
		},
		created() {
			let that = this;
		},
		mounted() {
			let that = this;
			// companyList({
			// 	page: 1,
			// 	page_size: 9999,
			// 	status: 1,
			// 	company_name: "",
			// 	company_userid: "",
			// 	manage_userid: "",
			// }).then((res1) => {
				// that.companyList = res1.data.data;
				usersList({
					page: 1,
					page_size: 9999,
					status: 1
				}).then((res2) => {
					that.isLoading = false;
					that.usersList = res2.data.data;
					if (that.$route.query.oid) {
						that.pageTitle = "Edit Department";
						departmentsDetail({
							id: that.$route.query.oid
						}).then((res) => {
							if (res.code == 200) {
								that.ruleForm = {
									id: res.data.id,
									departments_name: res.data.departments_name,
									description: res.data.description,
									// company_id: res.data.company_id,
									departments_userid: res.data.departments_userid,
								};
								that.userName = res.data.username;
							} else {

							}
						});
					} else {
						that.pageTitle = "Add Department";
					}
				});
			// });
		},
		watch: {
			//
		},
		methods: {
			openUserDialog() {
				let that = this;
				that.dialogVisible = true;
			},
			handleConfirm({
				id,
				user
			}) {
				let that = this;
				that.selectedId = id || null;
				that.ruleForm.departments_userid = id || null;
				that.userName = user ? user.username : "";
			},
			//取消
			cancel() {
				this.$router.back();
			},
			//保存
			submitForm(formName) {
				let that = this;
				that.$refs[formName].validate((valid) => {
					if (valid) {
						that.$toast.loading({
							duration: 0,
							forbidClick: true
						});
						if (that.pageTitle == "Add Department") {
							departmentsAdd(that.ruleForm).then((res) => {
								if (res.code == 200) {
									that.$toast.clear();
									that.$message.success("Operation successful");
									setTimeout(() => {
										window.location.reload();
									}, 800);
								} else {

								}
							});
						} else if (that.pageTitle == "Edit Department") {
							departmentsEdit(that.ruleForm).then((res) => {
								if (res.code == 200) {
									that.$toast.clear();
									that.$message.success("Operation successful");
									setTimeout(() => {
										window.location.reload();
									}, 800);
								} else {

								}
							});
						}
					} else {
						return false;
					}
				});
			},
		},
	};
</script>

<style lang="less" scoped>
	//主要内容
	.main_main {
		.page_main {
			padding: 18px 20px;

			.btn_box {
				text-align: center;

				.btn_el {
					margin-left: 10px;
					padding: 12px 24px;

					.van-button__text {
						font-size: 16px;
					}
				}
			}

			.form_box {
				.input_el {
					.tit {
						padding-bottom: 5px;
						font-size: 14px;
						color: #333333;
					}

					.required::before {
						content: "*";
						color: red;
						margin-right: 2px;
					}
				}
			}

			.btn_el {
				margin: 10px 0 20px 0;

				.tips {
					padding: 6px 8px;
					background-color: #ffb1001a;
					border-radius: 6px;
					font-size: 16px;
					font-weight: bold;
				}
			}
		}

		//页头
		.page_header {
			padding: 0 20px;
			height: 60px;
			line-height: 60px;
			background-color: #d8e4f0;
			font-size: 24px;
			font-weight: bold;
			box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
		}
	}
</style>
<style scoped>
	.main_box {
		height: calc(100vh - 60px);
		overflow-y: auto;
	}

	.main_box .main_main {
		position: relative;
		min-height: calc(100% - 0px);
		max-height: auto;
		background-color: #fafafa;
	}

	.el-header,
	.el-main {
		padding: 0;
	}
</style>